import React from 'react';

interface SvgSearchProps {
  color?: string;
  width?: number;
  height?: number;
}

const SvgSearch: React.FC<SvgSearchProps> = ({ 
  color = '#292D32',
  width = 24,
  height = 24 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 1047 1047" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M759.615 759.881L995.761 996.026" 
        stroke={color} 
        strokeWidth="101.205" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M51.1797 456.266C51.1797 679.842 232.424 861.087 456.001 861.087C567.981 861.087 669.348 815.619 742.634 742.137C815.67 668.912 860.821 567.862 860.821 456.266C860.821 232.69 679.576 51.4453 456.001 51.4453C232.424 51.4453 51.1797 232.69 51.1797 456.266Z" 
        stroke={color} 
        strokeWidth="101.205" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SvgSearch; 